import { render, staticRenderFns } from "./myReceiptOrders.vue?vue&type=template&id=d9158928&scoped=true&"
import script from "./myReceiptOrders.vue?vue&type=script&lang=js&"
export * from "./myReceiptOrders.vue?vue&type=script&lang=js&"
import style0 from "./myReceiptOrders.vue?vue&type=style&index=0&id=d9158928&prod&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9158928",
  null
  
)

export default component.exports